import React, {Component} from 'react';
import {Storage} from "../services/aws";
import './FileUploader.scss'

class FileUploader extends Component {

  fileInput = null;

  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      state: 'initial'
    }
  };

  uploadFile(event) {
    const file = event.target.files[0];
    let timestamp = Date.now();
    const s3Key = `${this.props.departmentGuid}/reports/${timestamp}/${file.name}`;

    this.setState({
      state: 'uploading'
    });

    Storage.put(s3Key, file, {
      contentType: file.type, partSize: 1024 * 1024 * 10,
      progressCallback: (progress) => {
        this.setState({
          progress: ((progress.loaded / progress.total) * 100).toFixed(0)
        })
      }
    })
      .then((result) => {
        const formData = {
          filename: file.name,
          s3Key: result.key,
        };
        this.props.onUpload(formData);

        this.setState({
          progress: 0,
          state: 'initial'
        })
      })
      .catch((error) => {
        console.log(error);
        console.log(`[AttachmentForm] uploadFile() error: ${JSON.stringify(error)}`);
      });

  }

  triggerUpload() {
    this.fileInput.click()
  }

  // ----------------------
  // Methods
  // ----------------------

  handleSubmit(event) {
    event.preventDefault();
  }

  render() {
    return (
      <div className="file-uploader">
        {this.state.state === 'initial'
          ? <div className="file-initial-upload" onClick={(e) => this.triggerUpload(e)}>
            <i className="fa fa-upload">
            </i>
            <div>Upload file</div>
            <input type="file" ref={el => {
              this.fileInput = el
            }} onChange={event => this.uploadFile(event)}/>
          </div>
          : null
        }
        {this.state.state === 'uploading'
          ? (
            <div className="attachment-form-upload file-uploading-state">
              <div className="upload-progress">
                <div className="progress-bar" style={{
                  transform: `translateX(-${100 - this.state.progress}%)`
                }}/>
              </div>
              <div className="percent">{this.state.progress}%</div>
            </div>
          )
          : null
        }
      </div>
    );
  }
}

export default FileUploader;
